import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import styles from './index.module.scss';

const Banner = () => {
    const { t } = useLang('Delta3AirStation.Banner');
    const dataA: EcoBannerProps = {
        layout: 'top-center',
        className: styles.comp,
        pc: 'https://websiteoss.ecoflow.com/upload/image/1762237210603/KV-1.webp',
        pad: 'https://websiteoss.ecoflow.com/upload/image/1762176606192/Frame%201612706725.webp',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1762176606192/Frame%201612706725.webp',
        label: t('label'),
        labelColor: '#ffffff',
        title: t.rich('title', {
            text1: (str: string) => <span className="mark">{str}</span>,
        }),
        desc: t('desc'),
        lBtnIsYouToBe: true,
        lChildren: t('btn_name'),
        lHref: 'https://www.youtube.com/embed/zKvYKIBJ5dI?si=EJW4ajYTXo1G3J6J',
        lType: 'filled',
        lTheme: 'blue',
        lDataLayer: {
            event: 'uaEvent',
            event_name: 'video',
            title_name: 'DELTA 3 1000 Air',
            position: 'Product Detail_1',
            __btn_type: 'common',
            __btn_id1: '__btn_l',
            __btn_id2: 'bannerBtnL',
        },
    };
    return (
        <section className={`${styles.Banner} GtmModuleData-section`} data-section-id="bannerA">
            <EcoBanner {...dataA} />
        </section>
    );
};

export default Banner;
